import React, { useEffect, useState } from 'react';
import Styles from './styles.module.css';
import DefaultTitle from '../title';
import DefaultDesc from '../desc';

type DefaultInputTime3Props = {
  error: boolean,
  title: string,
  value: string,
  setValue: (value: string) => void;
  desc?: string;
};

const DefaultInputTime3: React.FC<DefaultInputTime3Props> = ({ error, title, value, setValue, desc }) => {

  const [ year, setYear ] = useState('');
  const [ month, setMonth ] = useState('');
  const [ day, setDay ] = useState('');

  useEffect(() => {
    if (value) {
      const [y, m, d] = value.split('-');
      setYear(y || '');
      setMonth(m || '');
      setDay(d || '');
    } else {
      setYear('');
      setMonth('');
      setDay('');
    }
  }, [value]);

  const handleChange = (type: 'year' | 'month' | 'day', val: string) => {
    if (type === 'year') setYear(val);
    if (type === 'month') setMonth(val);
    if (type === 'day') setDay(val);

    const newYear = type === 'year' ? val : year;
    const newMonth = type === 'month' ? val : month;
    const newDay = type === 'day' ? val : day;
    const formatted = [newYear, newMonth, newDay].filter(Boolean).join('-');

    setValue(formatted);
  };

  return (
    <>
      <DefaultTitle
        title={title}
      />

      <div className={Styles.input}>
        <input
          style={error ? { border: ".5px solid #E31C5F", color: "#E31C5F" } : {}}
          placeholder="2026"
          maxLength={4}
          value={year}
          onChange={(e) => handleChange('year', e.target.value)}
        />
        <p>年</p>

        <input
          style={error ? { border: ".5px solid #E31C5F", color: "#E31C5F" } : {}}
          placeholder="4"
          maxLength={2}
          value={month}
          onChange={(e) => handleChange('month', e.target.value)}
        />
        <p>月</p>

        <input
          style={error ? { border: ".5px solid #E31C5F", color: "#E31C5F" } : {}}
          placeholder="1"
          maxLength={2}
          value={day}
          onChange={(e) => handleChange('day', e.target.value)}
        />
        <p>日</p>
      </div>

      {desc && ( <DefaultDesc text={desc} /> )}
    </>
  );
};

export default DefaultInputTime3;